/**
 * Clerk's own "Delete account" removes only the sign-in: it skips Bearri's cleanup (stored Google and Instagram access,
 * deal links, Stripe), so Bearri's Clerk screens never show it and deleting an account goes through support (Profile ›
 * Settings). One appearance, used twice: as ClerkProvider's default (src/index.tsx) and by openUserProfile (Profile.tsx).
 *
 * This only hides the section in the Clerk components Bearri renders. It doesn't reach Clerk's hosted Account Portal,
 * and it isn't the control: that is Clerk's per-user delete_self_enabled=false, which the backend sets when it first
 * creates a user's plan row, and scripts/clerk_self_delete_off.py for users from before that.
 *
 * `unsafe_disableDevelopmentModeWarnings` removes the orange "Development mode" stripe and label that a Clerk
 * development instance draws on every widget (sign-in, the invite sign-up, the profile modal). It hides nothing else:
 * "Secured by Clerk" stays, because Clerk's free plan terms don't allow removing it (src/components/auth/authAppearance.ts
 * styles it quiet, and its tests fail if anything hides the footer).
 */
export const CLERK_APPEARANCE = {
  layout: { unsafe_disableDevelopmentModeWarnings: true },
  elements: { profileSection__danger: { display: 'none' } },
};
